<template>
  <div>
    <v-container>
      <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
      <div v-else>
        <v-row dense class="mt-9">
          <v-row dense>
            <v-col>
              <v-card
                elevation="1"
                style="
                  border-radius: 10px;
                  position: relative;
                  overflow: visible;
                "
              >
                <v-card-text>
                  <v-row dense style="padding: 2vh">
                    <v-col cols="12" md="10">
                      <div class="d-flex align-start justify-start flex-column">
                        <span class="header">Gerenciar turmas</span>
                        <span class="regular mt-4"
                          >Atualize e gerencie suas turmas.</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" md="2" class="image-col"> </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-row>

        <v-row dense style="margin-top: 5vh">
          <v-row style="background-color: #e7e7eb; border-radius: 30px">
            <v-col class="d-flex align-center justify-center"
              ><strong>Código</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Nível</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Dias na semana</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Horários</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Alunos</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Status</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>Ações</strong></v-col
            >
          </v-row>
        </v-row>

        <v-row
          dense
          style="margin-top: 5vh"
          v-for="(item, index) in classes"
          :key="index"
        >
          <v-row style="background-color: #e7e7eb; border-radius: 30px">
            <v-col class="d-flex align-center justify-center"
              ><strong>{{ item.cod }}</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>{{ englishLevels[item.level] }}</strong></v-col
            >
            <v-col class="d-flex align-center justify-center flex-column">
              <v-chip
                v-for="(day, ind) in item.weekDays"
                :key="ind"
                small
                class="ma-1 primary"
                >{{ weekDaysItems[day].text }}</v-chip
              >
            </v-col>

            <v-col class="d-flex align-center justify-center flex-column">
              <v-chip
                v-for="(hour, ind) in item.hours"
                :key="ind"
                small
                class="ma-1 primary"
                >{{ hour }}</v-chip
              >
            </v-col>
            <v-col class="d-flex align-center justify-center"
              ><strong>{{ item.students?.length || 0 }}</strong></v-col
            >
            <v-col class="d-flex align-center justify-center"
              ><strong>{{ statuses[item.status] }}</strong></v-col
            >
            <v-col class="d-flex align-center justify-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    icon
                    @click="classDetails(item.id)"
                    ><v-icon>mdi-eye-outline</v-icon></v-btn
                  >
                </template>
                <span>Visualizar</span>
              </v-tooltip></v-col
            >
          </v-row>
        </v-row>

        <v-row
          dense
          style="margin-top: 5vh"
          v-if="classes.length === 0 && !loading"
        >
          <v-row class="text-center">
            <v-col class="d-flex align-center justify-center"
              ><span>Nenhuma turma encontrada</span></v-col
            >
          </v-row>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "PartnerClasses",
  created() {
    partnerApi
      .getStudyGroups()
      .then((res) => {
        this.classes = res.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      classes: [],

      typeOptions: [
        { text: "Individual", value: 1 },
        { text: "Dupla", value: 2 },
        { text: "Trio", value: 3 },
        { text: "Quarteto", value: 4 },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      frequencies: [
        { text: "Uma vez na semana", value: 1 },
        { text: "Duas vezes na semana", value: 2 },
      ],
      times: [
        {
          text: "1 Hora",
          value: 1,
        },
        {
          text: "1 Hora e 30 minutos",
          value: 2,
        },
      ],
      englishLevels: {
        0: "BEGGINER1",
        1: "BEGGINER2",
        2: "ESSENTIAL1",
        3: "ESSENTIAL2",
        4: "PREINTERMEDIATE1",
        5: "PREINTERMEDIATE2",
        6: "INTERMEDIATE1",
        7: "INTERMEDIATE2",
        8: "UPPER1",
        9: "UPPER2",
        10: "ADVANCED1",
        11: "ADVANCED2",
      },
      statuses: {
        0: "Em formação",
        1: "Ativa",
        2: "Encerrada",
      },
    };
  },
  methods: {
    classDetails(classId) {
      this.$router.push({
        path: `/connect/professor/turmas/${classId}`,
        params: classId,
      });
    },
  },
};
</script>

<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
